import { GeneratePSVFormV4ReturnObject } from "../../..";
import StringParser from "../core/PageParser/StringParser";
import ContentTemplate from "../core/PageTemplate/ContentTemplate";

export const ObjectiveSection = (data: GeneratePSVFormV4ReturnObject) => {
  return <ContentTemplate title="Objective" index={1}>    
    <StringParser>{data.basic.objective}</StringParser>
  </ContentTemplate>
}